














































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import ExpandableView from "../controls/ExpandableView.vue";
import Loading from "../general/Loading.vue";
import ImageSelectBase64 from "../general/ImageSelectBase64.vue";

import RentalBookingJson, {
  defaultRentalBookingJson,
  getRentalBookingTotalPrice,
} from "../../shared/RentalBookingJson";
import RentalConditionJson, {
  getRentalConditionPrice,
  defaultRentalConditionJson,
} from "../../shared/RentalConditionJson";
import RentalAccountJson, { defaultRentalAccountJson } from "../../shared/RentalAccountJson";
import { RentalBookingStatus, RentalBookingStatusNames } from "../../shared/RentalBookingStatus";
import RentalItemJson, { defaultRentalItemJson } from "../../shared/RentalItemJson";
import ClientJson from "../../shared/ClientJson";
import CustomerJson, { defaultCustomerJson } from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";
import { Gender } from "../../shared/Gender";
import { WeekDay } from "../../shared/WeekDay";

import SettingsJson, { getRentalTimeSlotsAtWeekDay } from "../../shared/SettingsJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalBookingJson, validateRentalBookingJsonAdd } from "../../shared/RentalBookingJson";
import { validateRentalItemJsonAdd } from "../../shared/RentalItemJson";

import RentalAccountSelect from "./RentalAccountSelect.vue";
import RentalProductSelect from "./RentalProductSelect.vue";
import RentalBookingPeriodSelect from "./RentalBookingPeriodSelect.vue";
import RentalBookingAdditionalConditionSelect from "./RentalBookingAdditionalConditionSelect.vue";
import RentalTimeSlotJson from "../../shared/RentalTimeSlotJson";
import FormCustomer from "../general/FormCustomer.vue";
import FormSepaMandate from "../general/FormSepaMandate.vue";

export default Vue.extend({
  name: "RentalBookingDetailsAdd",
  components: {
    OverlayWindow,
    PointerMenu,
    ExpandableView,
    Loading,
    RentalAccountSelect,
    RentalProductSelect,
    RentalBookingPeriodSelect,
    RentalBookingAdditionalConditionSelect,
    FormCustomer,
    FormSepaMandate,
    ImageSelectBase64
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Gender: Gender,
      getRentalTimeSlotsAtWeekDay: getRentalTimeSlotsAtWeekDay,
      RentalItemDefaultData: defaultRentalItemJson(),
      RentalBookingDefaultData: defaultRentalBookingJson(),
      RentalConditionDefaultData: defaultRentalConditionJson(),
      RentalAccountDefaultData: defaultRentalAccountJson(),
      CustomerDefaultData: defaultCustomerJson(),
      RentalBookingStatus: RentalBookingStatus,
      RentalBookingStatusNames: RentalBookingStatusNames,
      supportsDatePicker: false,
      editable: true,
      detailsTitle: "Buchung hinzufügen",
      UserPermissionRank: UserPermissionRank,
      showAccountSelect: false as boolean,
      showProductSelect: false as boolean,
      isInternalReservation: false as boolean,
      productSelectIndex: 0 as number,
      generalBookingDetails: null as RentalBookingJson | null,
      productsToBook: null as RentalBookingJson[] | null,
      rentalBookingTotalPrice: { priceIncludingVAT: 0, priceExcludingVAT: 0 } as {
        priceIncludingVAT: number;
        priceExcludingVAT: number;
      },
      useSepaMandate: false as boolean,
      pickupSlots: [] as (RentalTimeSlotJson[] | null)[],
      returnSlots: [] as (RentalTimeSlotJson[] | null)[],
      hasChanges: false,
      toValidate: {} as any,
      validation: [] as ValidationResult<RentalBookingJson>[],
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    init() {
      this.setDefaultData();
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    setDefaultData() {
      this.generalBookingDetails = { ...this.RentalBookingDefaultData };

      if (this.isInternalReservation) {
        this.generalBookingDetails.state = RentalBookingStatus.internalReservation;
        this.generalBookingDetails.rentalAccount = null;
      }

      //customer
      this.generalBookingDetails.customer = this.isInternalReservation ? null : { ...this.CustomerDefaultData };

      //account
      //this.generalBookingDetails.rentalAccount = this.isInternalReservation ? null : this.RentalAccountDefaultData;

      //products
      let defaultProductToBook: RentalBookingJson = { ...this.RentalBookingDefaultData };
      defaultProductToBook.rentalItem = { ...this.RentalItemDefaultData };

      this.productsToBook = [defaultProductToBook];
    },

    getDefaultSepaMandate(): SepaMandateJson {
      if (
        this.generalBookingDetails != null &&
        this.generalBookingDetails.client != null &&
        this.generalBookingDetails.client.sepaMandate != null
      ) {
        //use client sepa
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.generalBookingDetails.client.sepaMandate.accountHolderFirstName,
          accountHolderLastName: this.generalBookingDetails.client.sepaMandate.accountHolderLastName,
          addressStreet: this.generalBookingDetails.client.sepaMandate.addressStreet,
          addressZip: this.generalBookingDetails.client.sepaMandate.addressZip,
          addressCity: this.generalBookingDetails.client.sepaMandate.addressCity,
          addressCountry: this.generalBookingDetails.client.sepaMandate.addressCountry,
          IBAN: this.generalBookingDetails.client.sepaMandate.IBAN,
          BIC: this.generalBookingDetails.client.sepaMandate.BIC,
        };
      } else {
        //use default or customer info
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.generalBookingDetails?.customer
            ? this.generalBookingDetails.customer.guardianFirstName
            : "",
          accountHolderLastName: this.generalBookingDetails?.customer
            ? this.generalBookingDetails.customer.guardianLastName
            : "",
          addressStreet: this.generalBookingDetails?.customer ? this.generalBookingDetails.customer.addressStreet : "",
          addressZip: this.generalBookingDetails?.customer ? this.generalBookingDetails.customer.addressZip : "",
          addressCity: this.generalBookingDetails?.customer ? this.generalBookingDetails.customer.addressCity : "",
          addressCountry: this.generalBookingDetails?.customer
            ? this.generalBookingDetails.customer.addressCountry
            : "",
          IBAN: "",
          BIC: "",
        };
      }
    },

    //START set cached data

    //END set cached data

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any, index: number = 0) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.productsToBook != null) {
        if (this.generalBookingDetails != null) {
          this.productsToBook[index].rentalAccount = this.generalBookingDetails.rentalAccount;
          this.productsToBook[index].customer = this.generalBookingDetails.customer;
        }
        this.validation[index] = validateRentalBookingJsonAdd(this.productsToBook[index]);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    async loadPickupSlots(productsToBookIndex: number, item: RentalBookingJson) {
      if(this.settings.rentalRequestPickupAndReturnTime) {
        item.pickupTime = null;

        if(item.beginDate) {
          let weekDay = DateFormatter.parseISODate(item.beginDate)?.getDay();
          
          if(weekDay !== undefined) {
            this.pickupSlots[productsToBookIndex] = null;

            let rc = RestClient;
            try {
              this.pickupSlots[productsToBookIndex] = await rc.getRentalPickupReturnSlots(weekDay);
              this.$forceUpdate();
            } catch (e) {
              alert(e.message);
            }
          }
        }
      }
    },

    async loadReturnSlots(productsToBookIndex: number, item: RentalBookingJson) {
      if(this.settings.rentalRequestPickupAndReturnTime) {
        item.returnTime = null;

        console.log('endDate',item.endDate);
        if(item.endDate) {
          let weekDay = DateFormatter.parseISODate(item.endDate)?.getDay();
          
          console.log('weekDay',weekDay);
          if(weekDay !== undefined) {
            this.returnSlots[productsToBookIndex] = null;

            let rc = RestClient;
            try {
              this.returnSlots[productsToBookIndex] = await rc.getRentalPickupReturnSlots(weekDay);

              if(this.returnSlots[productsToBookIndex] != null && this.returnSlots[productsToBookIndex]!.length <= 0) {
                if(this.productsToBook && this.productsToBook[productsToBookIndex] && this.productsToBook[productsToBookIndex].rentalItem?.contactlessReturn) {
                  this.returnSlots[productsToBookIndex] = [{ "beginTime": "00:00", "endTime": "23:59" }];
                }
              }
              this.$forceUpdate();
            } catch (e) {
              alert(e.message);
            }
          }
        }
      }
    },

    addProductToBook() {
      if (this.productsToBook != null) {
        let newProductToBook: RentalBookingJson = {
          ...this.RentalBookingDefaultData,
        };
        newProductToBook.rentalItem = { ...this.RentalItemDefaultData };

        if (this.generalBookingDetails != null) {
          newProductToBook.rentalAccount = this.generalBookingDetails.rentalAccount;
          newProductToBook.customer = this.generalBookingDetails.customer;
        }

        this.productsToBook.push(newProductToBook);
      }
    },

    removeProductToBook(index: number) {
      if (this.productsToBook != null) {
        this.productsToBook.splice(index, 1);
        this.pickupSlots.splice(index, 1);
        this.returnSlots.splice(index, 1);

        delete this.toValidate["products-" + index];
      }
    },

    setCustomerData(data: ClientJson | null) {
      if (this.generalBookingDetails != null && this.generalBookingDetails.customer != null) {
        this.generalBookingDetails.customer.guardianOrganisation = data?.contact?.organisation ?? "";
        this.generalBookingDetails.customer.guardianFirstName = data?.contact?.firstName ?? "";
        this.generalBookingDetails.customer.guardianLastName = data?.contact?.lastName ?? "";
        this.generalBookingDetails.customer.email = data?.contact?.email ?? "";
        this.generalBookingDetails.customer.phone = data?.contact?.phone ?? "";
        this.generalBookingDetails.customer.addressStreet = data?.contact?.addressStreet ?? "";
        this.generalBookingDetails.customer.addressZip = data?.contact?.addressZip ?? "";
        this.generalBookingDetails.customer.addressCity = data?.contact?.addressCity ?? "";
        this.generalBookingDetails.customer.addressCountry = data?.contact?.addressCountry ?? "";
      }
    },

    selectRentalAccount(data: ClientJson | null) {
      if (this.generalBookingDetails != null) {
        this.generalBookingDetails.client = data;
        this.setCustomerData(data);

        if (data != null && data.sepaMandate != null) {
          this.useSepaMandate = true;
        } else {
          this.useSepaMandate = false;
        }

        this.toggleUseSepaMandate();
      }
    },

    selectRentalItem(item: RentalItemJson) {
      if (this.productsToBook != null) {
        this.productsToBook[this.productSelectIndex].rentalItem = item;
        this.inputValidation("rentalItem", "", this.productSelectIndex);
      }
    },

    calcRentalBookingTotalPrice() {
      let totalPrice = {
        priceIncludingVAT: 0,
        priceExcludingVAT: 0,
      };

      if (this.productsToBook != null) {
        for (let item of this.productsToBook) {
          let itemTotalPrice = getRentalBookingTotalPrice(item);

          totalPrice.priceIncludingVAT += itemTotalPrice.priceIncludingVAT;
          totalPrice.priceExcludingVAT += itemTotalPrice.priceExcludingVAT;
        }
      }

      this.rentalBookingTotalPrice.priceIncludingVAT = totalPrice.priceIncludingVAT;
      this.rentalBookingTotalPrice.priceExcludingVAT = totalPrice.priceExcludingVAT;
    },

    toggleUseSepaMandate() {
      if (this.generalBookingDetails != null) {
        if (this.useSepaMandate) {
          this.generalBookingDetails.sepaMandate = this.getDefaultSepaMandate();
        } else {
          this.generalBookingDetails.sepaMandate = null;
        }
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async addNewBooking() {
      if (this.productsToBook != null && this.generalBookingDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        for (let i = 0; i < this.productsToBook.length; i++) {
          this.productsToBook[i].client = this.generalBookingDetails.client;
          this.productsToBook[i].customer = this.generalBookingDetails.customer;
          this.productsToBook[i].isVATExempt = this.generalBookingDetails.isVATExempt;
          this.productsToBook[i].remarksVATExemption = this.generalBookingDetails.remarksVATExemption;

          this.validation[i] = validateRentalBookingJsonAdd(this.productsToBook[i]);

          if (this.validation[i] != null && this.validation[i].isValid == false) {
            this.loadingGeneral = false;
            //todo Validation Error anzeigen
            alert("Die Buchung konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
            return;
          }
        }

        for (let i = 0; i < this.productsToBook.length; i++) {
          await this.addRentalBooking(this.productsToBook[i]);
        }

        alert("Die Buchung wurde erfolgreich hinzugefügt.");
        this.$nextTick(() => {
          this.hasChanges = false;
          this.closeDetails();
        });
      }
    },

    async addRentalBooking(booking: RentalBookingJson) {
      try {
        let res = await this.restClient.addRentalBooking(booking);
      } catch (e) {
        this.loadingGeneral = false;
        alert(e.message);
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    generalBookingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },

    productsToBook: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.calcRentalBookingTotalPrice();
        }
      },
      deep: true,
    },

    isInternalReservation() {
      this.setDefaultData();
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    productNeedsIdDocument: function (): boolean {
      if(this.productsToBook) {
        return this.productsToBook.some((i: RentalBookingJson) => i.rentalItem ? (i.rentalItem.requestDriversLicense == true) : false);
      } else {
        return false;
      }
    }
  },
});
